import { render } from "./CreateVpnCustomerGateway.vue?vue&type=template&id=13178372&scoped=true"
import script from "./CreateVpnCustomerGateway.vue?vue&type=script&lang=js"
export * from "./CreateVpnCustomerGateway.vue?vue&type=script&lang=js"

import "./CreateVpnCustomerGateway.vue?vue&type=style&index=0&id=13178372&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos7-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.1.2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13178372"]])

export default __exports__